import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <h1 className="logo">
        <Link to={'/'} className="link">
            <span className="logo-name">IDEAL BRASIL</span>
            <img src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt="logo" />                            
        </Link>
        <img src={process.env.PUBLIC_URL + '/assets/images/logo-20a.png'} alt="logo" className="logo-20a" /> 
    </h1>
  )
}

export default Logo
